<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物料名称/编码">
              <a-input v-model.trim="queryParam.nameAndCode" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="业务类型">
              <a-select v-model="queryParam.businessTypeId" placeholder="请选择">
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in businessTypeSelect"
                  :key="index"
                  :value="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>

      <a-upload
        accept=".xls, .xlsx"
        :showUploadList="false"
        :action="config.importMaterUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus">导入</a-button>
      </a-upload>

      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>

      </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 2150 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
         <a @click="handleDel(record)">删除</a>
       <!-- <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleOpenLinkBusiness(record)">关联客户</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleOpenLinkSupplier(record)">关联供应商</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleOpenLinkBusinessType(record)">关联业务类型</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->
      </span>
    </s-table>

    <a-modal
      title="操作"
      style="top: 10px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="visible"
      @ok="handleOk"
      destroyOnClose
    >
      <a-form :form="form">
        <a-form-item label="物料名称" :label-col=" { span: 6}" :wrapper-col=" { span: 12 }">
          <a-input
            @blur="handleMaterNameChange"
            placeholder="请输入物料名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入物料名称'}]}]"
          />
        </a-form-item>

        <a-form-item label="物料编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            @blur="handleMaterCodeChange"
            placeholder="请输入物料编码"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入物料编码'}]}]"
          />
        </a-form-item>

        <a-form-item label="业务类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="业务类型"
            v-decorator="['businessTypeId', 
            { initialValue: mdl.businessTypeId, rules: [{ required: true, message: '请选择业务类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in businessTypeSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

         <a-form-item label="物料总量" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="物料总量" v-model="mdl.totalQuality" 
           v-decorator="['totalQuality', 
            { initialValue: mdl.totalQuality, rules: [{ required: true, message: '请输入物料总量'}]}]"
           />
        </a-form-item>

        <a-form-item label="物料描述" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="物料描述" v-model="mdl.description" />
        </a-form-item>

        <a-form-item label="物料标识" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="物料标识" v-model="mdl.identifying" />
        </a-form-item>

        <a-form-item label="物料规格" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="物料规格" v-model="mdl.materielSpec" />
        </a-form-item>

        <a-form-item label="包装类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="请选择包装类型"
            v-decorator="['materielType', 
            { initialValue: mdl.materielType, rules: [{ required: true, message: '请选择包装类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in materielTypeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
           <!--
        <a-form-item label="物料分组" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select placeholder="请选择物料分组" v-model="mdl.materielGroupId">
            <a-select-option
              v-for="(item, index) in materielGroupSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="是否需要采样" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-radio-group v-model="mdl.sampling" defaultValue="0">
            <a-radio-button
              v-for="(item, index) in yesOrNoSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="是否需要确认" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-radio-group v-model="mdl.verify" defaultValue="0">
            <a-radio-button
              v-for="(item, index) in yesOrNoSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="是否需要扣杂" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-radio-group v-model="mdl.deduct" defaultValue="0">
            <a-radio-button
              v-for="(item, index) in yesOrNoSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        -->
      </a-form>
    </a-modal>

    <a-modal
      title="关联客户"
      style="top: 80px;"
      :width="460"
      :heigh="720"
      v-model="linkBusinessVisible"
      @ok="linkBusinessOk"
      :confirmLoading="confirmLoading"
    >
      <template>
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          v-model="linkBusinessList"
          style="width: 80%"
          @change="linkBusinessChange"
          placeholder="请选择客户"
        >
          <a-select-option
            v-for="(item, index) in businessSelest"
            :key="index"
            :value="item.id"
          >{{item.name}}</a-select-option>
        </a-select>
      </template>
    </a-modal>

    <a-modal
      title="关联供应商"
      style="top: 80px;"
      :width="460"
      :heigh="720"
      v-model="linkSupplierVisible"
      @ok="linkSupplierOk"
      :confirmLoading="confirmLoading"
    >
      <template>
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          v-model="linkSupplierList"
          style="width: 80%"
          @change="linkSupplierChange"
          placeholder="请选择供应商"
        >
          <a-select-option
            v-for="(item, index) in supplierSelest"
            :key="index"
            :value="item.id"
          >{{item.name}}</a-select-option>
        </a-select>
      </template>
    </a-modal>

    <a-modal
      title="关联业务类型"
      style="top: 80px;"
      :width="460"
      :heigh="720"
      v-model="linkBusinessTypeVisible"
      @ok="linkBusinessTypeOk"
      :confirmLoading="confirmLoading"
    >
      <template>
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          v-model="linkBusinessTypeList"
          style="width: 80%"
          @change="linkBusinessTypeChange"
          placeholder="请选择业务类型"
        >
          <a-select-option
            v-for="(item, index) in businessTypeSelest"
            :key="index"
            :value="item.id"
          >{{item.name}}</a-select-option>
        </a-select>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  businessTypeList,
  getMaterielPage,
  materielDelete,
  materielSave,
  materielGroupList,
  checkMaterielNameIsExist,
  checkMaterielCodeIsExist,
  findNameOrCode,
  corpBusinessList,
  getCorpSupplierList,
  findBusinessByMaterielId,
  findSupplierByMaterielId,
  findBusinessTypeByMaterielId,
  materieLinkBusiness,
  materieLinkSupplier,
  materieLinkBusinessType,
  businessTypeListByCondition,
} from '@/api/basic'
import moment from 'moment'
import { getBizTextByValue } from '@/utils/util'
import { formatDate } from '../../utils/date.js'
import Bus from '@/layouts/bus'

export default {
  name: 'MaterielList',
  components: {
    STable
  },
  data() {
    return {
      roleId:null,
      pageSizeOptionsList:['10'],
      visible: false,
      linkBusinessVisible: false,
      linkSupplierVisible: false,
      linkBusinessTypeVisible: false,
      confirmLoading: false,

      // form: null,
      form: this.$form.createForm(this),
      mdl: {},
      disabled: true,

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},

      loading: false,
      showLoading: false,
      // 表头
      columns: [
        {
          title: '物料名称',
          dataIndex: 'name',
          width: '250px',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'code',
          width: '120px'
        },
        {
          title: '业务类型',
          dataIndex: 'businessTypeId',
          width: '120px',
          customRender: (text, record) => {
            return getBizTextByValue(this.businessTypeSelect, record.businessTypeId, text)
          }
        },
        {
          title: '包装类型',
          dataIndex: 'materielType',
          width: '120px',
          customRender: (text, record) => {
            return getBizTextByValue(this.materielTypeSelect, record.materielType, text)
          }
        },
         {
          title: '物料总量',
          dataIndex: 'totalQuality',
          width: '100px'
        },

        {
          title: '预约锁定量',
          dataIndex: 'lockQuality',
          width: '120px',
          color:  'red'
        },
        {
          title: '可用量',
          dataIndex: 'canuseQuality',
          width: '100px'
        },
        {
          title: '是否采样',
          dataIndex: 'sampling',
          width: '120px',
          customRender: (text, record) => {
            return text == '1' ? '是' : '否'
          }
        },
        {
          title: '是否确认',
          dataIndex: 'verify',
          width: '120px',
          customRender: (text, record) => {
            return text == '1' ? '是' : '否'
          }
        },
        {
          title: '是否扣杂',
          dataIndex: 'deduct',
          width: '120px',
          customRender: (text, record) => {
            return text == '1' ? '是' : '否'
          }
        },
        {
          title: '物料描述',
          dataIndex: 'description',
          width: '100px'
        },
        {
          title: '物料标识',
          dataIndex: 'identifying',
          width: '100px'
        },
        {
          title: '物料规格',
          dataIndex: 'materielSpec',
          width: '100px'
        },
        {
          title: '物料分组',
          dataIndex: 'materielGroupId',
          width: '120px',
          customRender: (text, record) => {
            return getBizTextByValue(this.materielGroupSelect, record.materielGroupId, text)
          }
        },
         {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getMaterielPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 业务类型
      businessTypeSelect: null,
      materielGroupSelect: null,
      materielTypeSelect: null,
      yesOrNoSelect: null,
      // 所有客户
      businessSelest: null,
      supplierSelest: null,
      businessTypeSelest: null,
      linkBusinessList: [],
      linkSupplierList: [],
      linkBusinessTypeList: [],

    }
  },
  created() {
    // 初始化查询条件
    this.tableOption()
    this.loadSelectData()
    this.roleId = this.$store.getters.roles
  },
  methods: {
    moment,
    handleMaterNameChange(e){
      var materName=e.target.value
      var materCode=''
      if(materName !='' && materName !=null){
        this.findNameCode (materName,materCode);
      }
    },
    handleMaterCodeChange(e){
      var materCode=e.target.value
      var materName=''
      if(materCode !='' && materCode !=null){
        this.findNameCode (materName,materCode);
      }
    },

    findNameCode (materName,materCode) {
      new Promise(resolve => {
        const data = findNameOrCode({"materName":materName,"materCode":materCode }).then(res => {
            return res.data })

        resolve(data)
      }).then(res => {
          var dataLength=res.length
          var codeOrName =''
          var  businessTypeId =''
        if(dataLength>0){
          businessTypeId =res[0].businessTypeId
              for(var i=0;i<dataLength;i++){
                  var item=res[i]
                  if(item !='' && item !=null){
                    codeOrName= codeOrName+','
                    if (materName != '' && materName != null) {
                      codeOrName = codeOrName + item.code
                    }
                    if (materCode != '' && materCode != null) {
                      codeOrName = codeOrName + item.name
                    }
                  }
              }
          codeOrName=codeOrName.substring(1)
        }
        if(codeOrName !='' && codeOrName !=null) {
          if (materName != '' && materName != null) {
            this.form.setFields({code: {value: codeOrName}})
            // this.mdl.code = codeOrName
          }
          if (materCode != '' && materCode != null) {
            this.form.setFields({name: {value: codeOrName}})
            //   this.mdl.name = codeOrName
          }
        }
        if(businessTypeId !='' && businessTypeId !=null) {
          var businessType = parseInt(businessTypeId)
          this.form.setFields({businessTypeId: {value: businessType}})
        }
      })
    },

    checkName(rule, value, callback) {
      if (!value) return
      let businessTypeId = this.form.getFieldValue('businessTypeId')
      if (!businessTypeId) {
        return
      }
      checkMaterielNameIsExist({ materielName: value, businessTypeId: businessTypeId })
        .then(res => {
          if (res.code === '0') {
            if (res.data) {
              callback('物料名称已经存在')
            } else {
              callback()
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },

    checkCode(rule, value, callback) {
      if (!value) return
      let businessTypeId = this.form.getFieldValue('businessTypeId')
      if (!businessTypeId) {
        return
      }
      checkMaterielCodeIsExist({ materielCode: value, businessTypeId: businessTypeId })
        .then(res => {
          if (res.code === '0') {
            if (res.data) {
              callback('物料编码已经存在')
            } else {
              callback()
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = materielGroupList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.materielGroupSelect = res
      })
      new Promise(resolve => {
        const data = corpBusinessList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.businessSelest = res
      })
      new Promise(resolve => {
        const data = getCorpSupplierList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.supplierSelest = res
      })
      new Promise(resolve => {
        const data = businessTypeListByCondition().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.businessTypeSelest = res
      })
      this.materielTypeSelect = this.$store.getters.codeList.basic_factory_load_port_materiel_type
      this.yesOrNoSelect = this.$store.getters.codeList.sys_yes_or_no
      this.businessTypeSelect = this.$store.getters.bizList
    },

    filterOption (input, option) { // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
      this.disabled = true
    },
    handleAdd() {
      this.mdl = {}
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      this.visible = true
      this.disabled = false
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) {
          this.showLoading = true
          materielSave(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(res => {
              this.showLoading = false
            })
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return materielDelete(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel() {}
      })
    },

    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        Bus.$emit('showSpinning', true, '准备导入...')
      }

      if (info.file.status === 'done') {
        Bus.$emit('showSpinning', false)
        if (info.file.response && info.file.response.code === '0') {
          this.$message.success('导入成功！')
          this.$refs.table.refresh()
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    beforeUpload(file) {},
    downLoad() {
      let url = this.config.downLoadMouldUrl + '物料.xlsx'
      window.location.href = url
    },
    clickTool(){
      window.location.href = "ireport://"

    },
    handleOpenLinkBusiness(record) {
      this.linkBusinessList.length = 0
      this.mdl = Object.assign({}, record)
      let nthis = this
      findBusinessByMaterielId({ materielId: record.id }).then(res => {
        let ids = new Array()
        for (let i = 0; i < res.data.length; i++) {
          ids.push(res.data[i].id)
        }
        nthis.linkBusinessList = ids
        nthis.linkBusinessVisible = true
      })
    },
    handleOpenLinkSupplier(record) {
      this.linkSupplierList.length = 0
      this.mdl = Object.assign({}, record)
      let nthis = this
      findSupplierByMaterielId({ materielId: record.id }).then(res => {
        let ids = new Array()
        for (let i = 0; i < res.data.length; i++) {
          ids.push(res.data[i].id)
        }
        nthis.linkSupplierList = ids
        nthis.linkSupplierVisible = true
      })
    },
    handleOpenLinkBusinessType(record) {
      this.linkBusinessTypeList.length = 0
      this.mdl = Object.assign({}, record)
      let nthis = this
      findBusinessTypeByMaterielId({ materielId: record.id }).then(res => {
        let ids = new Array()
        for (let i = 0; i < res.data.length; i++) {
          ids.push(res.data[i].id)
        }
        nthis.linkBusinessTypeList = ids
        nthis.linkBusinessTypeVisible = true
      })
    },
    linkBusinessChange(value) {
      this.linkBusinessList = value
    },
    linkSupplierChange(value) {
      this.linkSupplierList = value
    },
    linkBusinessTypeChange(value) {
        this.linkBusinessTypeList =value
    },
    linkBusinessOk() {
      this.confirmLoading = true
      let businesses = ''
      for (let i = 0, len = this.linkBusinessList.length; i < len; i++) {
        if (this.linkBusinessList[i] != undefined) {
          businesses += this.linkBusinessList[i] + ','
        }
      }

      businesses = businesses.substring(0, businesses.length - 1)
      materieLinkBusiness({ businessIds: businesses, materielIds: this.mdl.id })
        .then(res => {
       //   this.$message.success('设置成功')
        })
        .catch(() => {})
        .finally(() => {
          this.confirmLoading = false
          this.linkBusinessVisible = false
        })
    },
    linkSupplierOk() {
      this.confirmLoading = true
      let supplieres = ''
      for (let i = 0, len = this.linkSupplierList.length; i < len; i++) {
        if (this.linkSupplierList[i] != undefined) {
          supplieres += this.linkSupplierList[i] + ','
        }
      }

      supplieres = supplieres.substring(0, supplieres.length - 1)
      materieLinkSupplier({ supplierIds: supplieres, materielIds: this.mdl.id })
        .then(res => {
        //  this.$message.success('设置成功')
        })
        .catch(() => {})
        .finally(() => {
          this.confirmLoading = false
          this.linkSupplierVisible = false
        })
    },
    linkBusinessTypeOk() {
      this.confirmLoading = true
      let businessTypes = ''
      for (let i = 0, len = this.linkBusinessTypeList.length; i < len; i++) {
        if (this.linkBusinessTypeList[i] != undefined) {
          businessTypes += this.linkBusinessTypeList[i] + ','
        }
      }
      businessTypes = businessTypes.substring(0, businessTypes.length - 1)
      materieLinkBusinessType({ businessTypeIds: businessTypes, materielIds: this.mdl.id })
        .then(res => {
          //  this.$message.success('设置成功')
        })
        .catch(() => {})
        .finally(() => {
          this.confirmLoading = false
          this.linkBusinessTypeVisible = false
        })
    },

  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>

<style scoped>
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>